module.exports = __webpack_public_path__ + "static/media/Modal.4dc3cb84.scss";


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal/Modal.scss
// module id = 670
// module chunks = 0